import VehicleTracking from './VehicleTracking';

export default VehicleTracking;